<template>
  <span ref="iconRef"></span>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue'
  import { UserIcon, BuildingIcon, BookOpenIcon } from 'lucide-vue-next'
  import { createApp, h } from 'vue'

  const props = defineProps<{
    type: 'user' | 'building' | 'book'
  }>()

  const iconRef = ref<HTMLElement | null>(null)

  onMounted(() => {
    if (!iconRef.value) return

    const IconComponent = {
      user: UserIcon,
      building: BuildingIcon,
      book: BookOpenIcon
    }[props.type]

    const app = createApp({
      render() {
        return h(IconComponent, {
          class: 'me-1 h-2.5 w-2.5 text-purple-600'
        })
      }
    })

    app.mount(iconRef.value)
  })
</script>
